import React from 'react'
import logo from "../assets/logo.png"

const Loader = () => {
  return (
    <div style={{height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <style>
        {`
          @keyframes fade {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}
      </style>
      <img src={logo} alt="Logo" width={150} style={{
          animation: 'fade 2s infinite',
        }}/>
    </div>
  )
}

export default Loader
